import { render } from "./TheCabinetOff.vue?vue&type=template&id=18b2e3ce&ts=true"
import script from "./TheCabinetOff.vue?vue&type=script&lang=ts"
export * from "./TheCabinetOff.vue?vue&type=script&lang=ts"

import "./TheCabinetOff.vue?vue&type=style&index=0&id=18b2e3ce&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__